export default {
    state: {
        header: {},
    },
    mutations: {
        writeHeader: (state, pair) => state.header[pair[0]] = pair[1],
    },
    actions: {
        setHeader: (ctx, pair) => {
            ctx.commit('writeHeader', pair);
        },
    },
    getters: {
        getHeader: state => state.header,
    },
};